// @flow
import * as React from 'react';
import {useApi} from 'docs/data';
import Box from 'sail/Box';
import {Button} from 'sail/Button';
import {FormattedMessage} from 'react-intl';

type EnableACHButtonProps = {|
  children: React.Node,
|};

export const EnableACHButton = ({children}: EnableACHButtonProps) => {
  const {api} = useApi();
  const [pending, setPending] = React.useState(false);
  const [enabled, setEnabled] = React.useState(false);

  const onClick = async () => {
    if (enabled) {
      return;
    }
    setPending(true);

    await api.acceptAchTos();
    setEnabled(true);
    setPending(false);
  };

  return (
    <Box padding={{vertical: 4}}>
      {enabled ? (
        <Button
          color="white"
          disabled
          icon="check"
          label={
            <FormattedMessage
              id="docsShell.enableACHButton.ACHactivated"
              description="Button label used when direct bank transfer (ACH) is already activated"
              defaultMessage="ACH Activated"
            />
          }
        />
      ) : (
        <Button
          color="blue"
          label={
            <FormattedMessage
              id="docsShell.enableACHButton.enableACH"
              description="Button label used when enabling direct bank transfer (ACH)"
              defaultMessage="Enable ACH"
            />
          }
          onClick={onClick}
          pending={pending}
        />
      )}
    </Box>
  );
};
